import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import Axios from 'axios';
import men_teacher from "../assets/img/men-teacher.png";
import girl_teacher from "../assets/img/girl-teacher.png";
import { URL_LIST_ALL } from '../configs/api';
import moment from 'moment';
import ViewUserInfo from '../component/ViewUserInfo';
import iconsend from "../assets/img/icon-send.png";
import { checkRole } from '../model';
import { confirmAlert } from 'react-confirm-alert';
import { badWords } from '@vnphu/vn-badwords';
import Spinner from '../component/Spinner';

const PostsComment = ({ post, viewmore, initialComments, onCommentChange }) => {
    const { savecomment } = useSelector((state) => state.save);
    const { user } = useSelector((state) => state.auth);

    const [comments, setComments] = useState([]);
    const [replyTo, setReplyTo] = useState(null);
    const [loading, setLoading] = useState(false);
    const [hoveredUserId, setHoveredUserId] = useState(null);

    const [showModalSticker, setShowModalSticker] = useState(false);
    const [showModalReplySticker, setShowModalReplySticker] = useState(false);
    const [stickerReplySelect, setStickerReplySelect] = useState("");
    const [stickerSelect, setStickerSelect] = useState("");
    const [listSticker, setListSticker] = useState([]);
    const stickerRef = useRef(null);
    const stickerReplyRef = useRef(null);


    const commentInputRef = useRef(null);
    const commentInputReplyRef = useRef(null);
    const timeoutRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (stickerRef.current && !stickerRef.current.contains(event.target)) {
                setShowModalSticker(false);
            }
            if (stickerReplyRef.current && !stickerReplyRef.current.contains(event.target)) {
                setShowModalReplySticker(false);
            }
        };

        if (showModalSticker || showModalReplySticker) {
            document.addEventListener('mousedown', handleClickOutside);
            Axios.get(URL_LIST_ALL + 'posts_sticker?status=1', user.config).then(res => {
                if (res.data.status === "success") {
                    const allStickers = res.data.data.flatMap(item => item.url);
                    setListSticker(prev => {
                        const uniqueUrls = allStickers.filter(url => !prev.includes(url));
                        return [...prev, ...uniqueUrls];
                    });
                }
            }).catch(console.error);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showModalSticker, showModalReplySticker]);

    useEffect(() => {
        if (!Array.isArray(initialComments)) return;
        const topLevel = initialComments.filter(c => c.parent_id === 0);
        const replies = initialComments.filter(c => c.parent_id !== 0);
        const mapped = topLevel.map(parent => ({
            ...parent,
            replies: replies
                .filter(reply => reply.parent_id === parent.id)
                .sort((a, b) => a.datecreate - b.datecreate) // Sắp xếp id tăng dần
        }));
        // Nếu cũng muốn sắp xếp comment cha
        mapped.sort((a, b) => b.datecreate - a.datecreate);

        setComments(mapped);
    }, [initialComments]);

    useEffect(() => {
        if (savecomment && savecomment.post_id === post.id) {
            setComments(prev => {
                let updated = [...prev];

                // Nếu comment bị xóa
                if (savecomment.status === 0) {
                    // Nếu là comment con: xóa khỏi replies của comment cha
                    if (savecomment.parent_id !== 0) {
                        const parentIndex = updated.findIndex(c => c.id === savecomment.parent_id);
                        if (parentIndex !== -1) {
                            let parent = { ...updated[parentIndex] };
                            parent.replies = parent.replies?.filter(r => r.id !== savecomment.id) || [];
                            updated[parentIndex] = parent;
                        }
                    } else {
                        // Nếu là comment cha: xóa khỏi danh sách
                        updated = updated.filter(c => c.id !== savecomment.id);
                    }
                } else {
                    // Nếu là thêm/sửa comment
                    if (savecomment.parent_id !== 0) {
                        const parentIndex = updated.findIndex(c => c.id === savecomment.parent_id);
                        if (parentIndex !== -1) {
                            const parentOriginal = updated[parentIndex];
                            const parent = {
                                ...parentOriginal,
                                replies: [
                                    ...(parentOriginal.replies || []).filter(r => r.id !== savecomment.id),
                                    savecomment
                                ].sort((a, b) => a.datecreate - b.datecreate) // giữ thứ tự tăng dần
                            };
                            updated[parentIndex] = parent;
                        }
                    } else {
                        updated = [
                            savecomment,
                            ...updated.filter(c => c.id !== savecomment.id)
                        ].sort((a, b) => b.datecreate - a.datecreate); // cha giảm dần
                    }
                }

                return updated;
            });
        }
    }, [savecomment, post]);


    useEffect(() => {
        onCommentChange?.(comments);
    }, [comments, onCommentChange]);

    const handleSubmit = async (e, parentId = 0) => {
        e.preventDefault();

        const ref = parentId === 0 ? commentInputRef : commentInputReplyRef;
        let newComment = ref.current.innerHTML.trim();

        if (!newComment && !(parentId === 0 ? stickerSelect : stickerReplySelect)) return;
        newComment = `<div class='w-100'>${newComment}</div>`
        if (parentId === 0 && stickerSelect) {
            newComment += `<img src="${stickerSelect}" class="sticker"/>`;
        }
        if (parentId !== 0 && stickerReplySelect) {
            newComment += `<img src="${stickerReplySelect}" class="sticker"/>`;
        }

        try {
            setLoading(true);
            newComment = badWords(newComment, '*');
            newComment = await processImagesInComment(newComment);

            const values = {
                user_id: user.data.id,
                post_id: post.id,
                comments: newComment,
                status: 1,
                parent_id: parentId
            };

            const res = await Axios.post(URL_LIST_ALL + 'posts_comment', values, user.config);
            if (res.data.status === "success") {
                ref.current.innerHTML = '';
                setReplyTo(null);
                setStickerSelect('');
                setStickerReplySelect('');
            } else {
                alert(res.data.message);
            }
        } catch (err) {
            console.error("Lỗi gửi bình luận:", err);
        } finally {
            setLoading(false);
        }
    };


    const deleteComment = (comment_id) => {
        confirmAlert({
            title: 'Xác nhận',
            message: 'Bạn có chắc muốn xóa bình luận này?',
            buttons: [
                {
                    label: 'Có',
                    onClick: () => {
                        Axios.put(URL_LIST_ALL + 'posts_comment/' + comment_id, { status: 0 }, user.config)
                            .then(res => {
                                if (res.data.status === "success") {
                                    alert("Xóa bình luận thành công");
                                } else {
                                    alert(res.data.message);
                                }
                            }).catch(err => console.log(err));
                    }
                },
                { label: 'Không' }
            ]
        });
    };

    const convertImageToBlobAfterResize = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const img = new Image();
                img.src = reader.result;
                img.onload = () => {
                    const maxSize = 2048;
                    const scale = Math.min(maxSize / img.width, maxSize / img.height, 1);
                    const canvas = document.createElement('canvas');
                    canvas.width = img.width * scale;
                    canvas.height = img.height * scale;
                    const ctx = canvas.getContext('2d');
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error("Resize thất bại")), "image/jpeg", 1);
                };
                img.onerror = reject;
            };
            reader.onerror = reject;
        });
    };

    const processImagesInComment = async (htmlContent) => {
        const container = document.createElement("div");
        container.innerHTML = htmlContent;

        const imgTags = container.querySelectorAll("img");
        for (const img of imgTags) {
            const src = img.getAttribute("src");
            if (src?.startsWith("data:image") || src?.startsWith("blob:")) {
                const res = await fetch(src);
                const blob = await res.blob();
                const resizedBlob = await convertImageToBlobAfterResize(blob);
                const formData = new FormData();
                formData.append("file", resizedBlob, "upload.jpg");
                formData.append("changename", 1);
                formData.append("folder", 0);

                const response = await Axios.post(URL_LIST_ALL + 'fileupload', formData, user.config);
                if (response.data.status === "success") {
                    img.setAttribute("src", response.data.message);
                }
            }
        }

        return container.innerHTML;
    };

    const handlePaste = async (e, ref) => {
        const items = e.clipboardData?.items;
        if (!items) return;

        for (const item of items) {
            if (item.type.indexOf("image") !== -1) {
                e.preventDefault();

                const file = item.getAsFile();
                const reader = new FileReader();

                reader.onload = (event) => {
                    const img = document.createElement("img");
                    img.src = event.target.result;
                    img.style.maxWidth = "100%";
                    img.style.borderRadius = "6px";
                    ref.current.appendChild(img);
                };

                reader.readAsDataURL(file);
            }
        }
    };

    return (
        <div className="comment-wrapper">
            {/* Form bình luận gốc */}
            <form onSubmit={(e) => handleSubmit(e, 0)} className="comment-form mb-3">
                <div className="d-flex">
                    <div
                        ref={commentInputRef}
                        contentEditable
                        className="comment-editable"
                        placeholder="Viết bình luận..."
                        onPaste={(e) => handlePaste(e, commentInputRef)}
                    />
                    <div className="sticker-group">
                        <button className="btn btn-add-sticker" type='button' onClick={() => setShowModalSticker(!showModalSticker)}>
                            <i className='far fa-smile-beam'></i>
                        </button>

                        {showModalSticker && (
                            <div className='sticker-modal'>
                                <div ref={stickerRef} className='wrapper bg-white shadow-sm border'>
                                    <div className='row'>
                                        {listSticker.map((item, i) => (
                                            <div className='col-3' key={i}>
                                                <button type='button' className='w-100 btn-sticker' onClick={() => { setStickerSelect(item); setShowModalSticker(false); }}>
                                                    <img src={item} alt={`sticker-${i}`} style={{ width: "100%" }} />
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <button className="btn btn-sender ml-2" type="submit" disabled={loading}>
                        {loading ? <Spinner /> : <img src={iconsend} alt="Gửi" />}
                    </button>
                </div>
                {stickerSelect && (
                    <div className='w-100 stiker-show'>
                        <div className='border shadow-sm wrapper mt-1 p-2'>
                            <img src={stickerSelect} alt='sticker chọn' />
                        </div>
                    </div>
                )}
            </form>

            <div className="comment-list">
                {(viewmore ? comments : comments.slice(0, 3)).map((comment) => (
                    <div key={comment.id} className="comment-item w-100">
                        <div className="comment-wrapper">
                            <div className="comment-avatar">
                                <div
                                    className="avatar-circle cursor-pointer position-relative"
                                    onMouseEnter={() => {
                                        clearTimeout(timeoutRef.current);
                                        timeoutRef.current = setTimeout(() => setHoveredUserId(comment.id), 300);
                                    }}
                                    onMouseLeave={() => {
                                        clearTimeout(timeoutRef.current);
                                        setHoveredUserId(null);
                                    }}
                                >
                                    <img className="avatar shadow-sm" src={comment.avatar || (comment.sex === 'Nam' ? men_teacher : girl_teacher)} />
                                    {hoveredUserId === comment.id && <ViewUserInfo user_id={comment.user_id} />}
                                </div>
                            </div>
                            <div className="comment-content">
                                <div className="comment-header">
                                    <strong>{comment.fullname}</strong>
                                    <small>({comment.part_name} | {comment.company_name})</small>
                                </div>
                                <div className='comment-text' dangerouslySetInnerHTML={{ __html: comment.comments }} />
                                <div className='w-100 d-flex justify-content-end align-items-center'>
                                    <button className="btn btn-link btn-sm p-0 btn-reply" type="button" onClick={() => setReplyTo(replyTo === comment.id ? null : comment.id)}>
                                        {replyTo === comment.id ? 'Hủy' : 'Trả lời'}
                                    </button>
                                    <div className="comment-date">{moment(comment.datecreate * 1000).format('HH:mm DD-MM-YYYY')}</div>
                                </div>

                                {checkRole(user, 'deletecomment', '') &&
                                    <button className='delete-comment btn btn-sm text-danger ml-2' type='button' onClick={() => deleteComment(comment.id)}>
                                        <i className='far fa-trash-alt'></i>
                                    </button>}
                            </div>


                        </div>

                        {/* Module reply riêng biệt */}
                        <div className="module-reply ml-5 mt-2">
                            {comment.replies?.map((reply) => (
                                <div key={reply.id} className="comment-item reply ml-4 mt-2 pl-2">
                                    <div className='w-100 d-flex comment-wrapper'>
                                        <div className="comment-avatar">
                                            <div
                                                className="avatar-circle cursor-pointer position-relative"
                                                onMouseEnter={() => {
                                                    clearTimeout(timeoutRef.current);
                                                    timeoutRef.current = setTimeout(() => setHoveredUserId(reply.id), 300);
                                                }}
                                                onMouseLeave={() => {
                                                    clearTimeout(timeoutRef.current);
                                                    setHoveredUserId(null);
                                                }}
                                            >
                                                <img className="avatar shadow-sm" src={reply.avatar || (reply.sex === 'Nam' ? men_teacher : girl_teacher)} />
                                                {hoveredUserId === reply.id && <ViewUserInfo user_id={reply.user_id} />}
                                            </div>
                                        </div>
                                        <div className="comment-content">
                                            <div className="comment-header">
                                                <strong>{reply.fullname}</strong>
                                                <small>({reply.part_name} | {reply.company_name})</small>
                                            </div>
                                            <div className='comment-text' dangerouslySetInnerHTML={{ __html: reply.comments }} />
                                            <div className="comment-date">
                                                {moment(reply.datecreate * 1000).format('HH:mm DD-MM-YYYY')}
                                            </div>
                                            {checkRole(user, 'deletecomment', '') &&
                                                <button className='delete-comment btn btn-sm text-danger ml-2' type='button' onClick={() => deleteComment(reply.id)}>
                                                    <i className='far fa-trash-alt'></i>
                                                </button>}
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {replyTo == comment.id && (
                                <form onSubmit={(e) => handleSubmit(e, comment.id)} className="comment-form reply-form mt-2">
                                    <div className="d-flex">
                                        <div
                                            ref={commentInputReplyRef}
                                            contentEditable
                                            className="comment-editable reply"
                                            placeholder="Nhập trả lời..."
                                            onPaste={(e) => handlePaste(e, commentInputReplyRef)}
                                        />
                                        <div className="sticker-group">
                                            <button className="btn btn-add-sticker" type='button' onClick={() => setShowModalReplySticker(!showModalReplySticker)}>
                                                <i className='far fa-smile-beam'></i>
                                            </button>

                                            {showModalReplySticker && (
                                                <div className='sticker-modal'>
                                                    <div ref={stickerReplyRef} className='wrapper bg-white shadow-sm border'>
                                                        <div className='row'>
                                                            {listSticker.map((item, i) => (
                                                                <div className='col-3' key={i}>
                                                                    <button type='button' className='w-100 btn-sticker' onClick={() => { setStickerReplySelect(item); setShowModalReplySticker(false); }}>
                                                                        <img src={item} alt={`sticker-${i}`} style={{ width: "100%" }} />
                                                                    </button>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        <button className="btn btn-sender ml-2" type="submit">
                                            {loading ? <Spinner /> : <img src={iconsend} />}
                                        </button>
                                    </div>
                                    {stickerReplySelect && (
                                        <div className='w-100 stiker-show'>
                                            <div className='border shadow-sm wrapper mt-1 p-2'>
                                                <img src={stickerReplySelect} alt='sticker chọn' />
                                            </div>
                                        </div>
                                    )}
                                </form>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};



export default PostsComment;
